<template>
  <div class="official" id="official">
    <div class="official-con" v-if="list.length > 0 ">
      <div class="top">
        <img :src="list[0].mobileImg" @click="list[0].status == 3?'':toLive(list[0])" alt />
      </div>
      <!-- <span v-if="datetimeshow" class="dowe-time">
        <p>距离报告发布还有: <b>{{odatetime.minutes}}</b> 分 <b>{{odatetime.seconds}}</b> 秒</p>
      </span> -->
      <span class="bottom">
        <!-- <p class="time"> -->
        <!-- <i></i> -->
        <!-- {{item.timeBuckets}}
        </p> -->
        <p class="o-tit ofw-hide-2">{{list[0].name}}</p>
        <dl class="fix" v-for="(item,index) in list" :key="index">
          <dt>
            <img :src="item.head" :alt="item.head" @click="item.status == 3?'':toLive(item)" />
            <!-- <span v-if="item.status == 1" class="btn1" @click="toLive(item)">马上开播</span>
            <span v-if="item.status == 2" class="btn2" @click="toLive(item)">点击观看</span>
            <span v-if="item.status == 3" class="btn3">直播结束</span> -->
          </dt>
          <dd>
            <h5>{{item.teacherName}}</h5>
            <b>{{item.position}}</b>
            <div>
              <p class="">{{item.introduction}}</p>
            </div>
          </dd>
        </dl>
        <span v-if="list[0].status == 1" class="btn1" @click="toLive(list[0])">马上开播</span>
        <span v-if="list[0].status == 2" class="btn2" @click="toLive(list[0])">点击观看</span>
        <span v-if="list[0].status == 3" class="btn3">直播结束</span>
      </span>
    </div>

    <!-- 重复预约弹窗 -->
    <div class="tc-bg" v-show="popShow == 1">
      <div class="tc">
        <img src="@/assets/images/close.png" class="close" @click="popClose" alt />
        <img src="@/assets/images/tc_tu1.jpg" class="warning" alt style="margin-top:0.6rem" />
        <p>发布会未开始</p>
        <div style="height:0.2rem"></div>
        <div class="btn">
          <button class="btn2" @click="popClose">确定</button>
        </div>
      </div>
    </div>

    <div class="tc-bg" v-show="popShow == 2">
      <div class="tc">
        <img src="@/assets/images/close.png" class="close" @click="popClose" alt />
        <img src="@/assets/images/tc_tu1.jpg" class="warning" style="margin-top:0.6rem" alt />
        <p>发布会已结束</p>
        <div style="height:0.2rem"></div>
        <div class="btn">
          <button class="btn2" @click="popClose">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOfficial, baseUrl } from "@/api/home";

export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
    expoId: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      list: [],
      popShow: 0, //0 默认什么都不打开 1 发布会未开始 2 发布会已结束
      liveId: 0,
      item: {},
      datetimeshow: false,
      begintime: "2020-11-28 9:00:00",
      endtime: "2020-11-28 10:00:00",
      odatetime: { days: 0, hours: 0, minutes: 0, seconds: 0 },
    };
  },
  computed: {},
  methods: {
    async getOfficial() {
      let { succ, results } = await getOfficial({
        params: {
          expoId: this.expoId,
        },
      });
      console.log(results);
      if (succ) {
        //console.log(results);
        this.list = results;
        this.dateTimeShow();
      }
    },

    dateTimeShow() {
      //当前时间
      let date = new Date();
      let now = date.getTime();
      //开始展示倒计时时间
      let beginDate = new Date(this.begintime);
      let begin = beginDate.getTime();
      //结束倒计时时间
      let endDate = new Date(this.endtime);
      let end = endDate.getTime();
      let myVar;
      if (now >= begin && now < end) {
        this.datetimeshow = true;
        myVar = setInterval(this.loveTime, 1000);
      }
      if (now >= end && this.datetimeshow == true) {
        this.datetimeshow = false;
        if (myVar) {
          clearInterval(myVar);
        }
      }
    },

    loveTime() {
      //获取当前时间
      let date = new Date();
      let now = date.getTime();
      //设置截止时间
      let endDate = new Date(this.endtime);
      let end = endDate.getTime();
      //时间差
      let leftTime = end - now;
      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        this.odatetime.days = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.odatetime.hours = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.odatetime.minutes = Math.floor((leftTime / 1000 / 60) % 60);
        this.odatetime.seconds = Math.floor((leftTime / 1000) % 60);
      }
      if (now >= end) {
        this.datetimeshow = false;
      }
    },

    // 点击正在直播
    toLive(item) {
      //console.log(item);
      if (item) {
        this.item = item;
      }
      let liveId = this.item.liveId; //直播id
      let status = this.item.status; //直播状态
      let currTime = parseInt(new Date().getTime() / 1000); //当前时间
      let startTime = this.item.startTime - 1800; //提前30分钟的开始时间
      let endTime = Number(this.item.endTime); //结束时间

      if (!this.isLogin) {
        this.$emit("showLogin", "official");
        return;
      }
      if (currTime < startTime) {
        this.popShow = 1;
        //console.log("发布会未开始");
        return;
      }

      if (currTime > endTime) {
        this.popShow = 2;
        //console.log("发布会已结束");
        return;
      }

      if ((currTime > startTime && currTime < endTime) || status == 2) {
        //console.log("已经到了直播时间的提前1小时,可以进直播");
        window.location.href = `${baseUrl}/live/watch?id=${liveId}`;
      }
    },

    popClose() {
      this.popShow = 0;
    },
  },
  created() {
    if (this.expoId) {
      this.getOfficial();
    }
  },
  watch: {
    expoId(newVal) {
      if (newVal) {
        this.getOfficial();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.official {
  padding: 0.32rem 0.22rem;
  .official-con {
    // margin: 0.5rem 0.3rem;
    border-radius: 0.25rem;
    // background: #fff url("~@/assets/images/official_bg.png");
    // background-size: 100% 100%;
    background-color: #fff;
    overflow: hidden;
    position: relative;
    .top {
      // height: 4rem;
      //padding: 0.3rem;
      img {
        width: 100%;
        // height: 100%;
        background-color: pink;
      }
    }
    .dowe-time {
      background: url("~@/assets/images/down_time.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 0.42rem;
      right: 0.11rem;
      height: 0.5rem;
      p {
        font-size: 0.22rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #505050;
        margin: 0 0.21rem 0 0.83rem;
        b {
          font-size: 0.3rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #f12d31;
        }
      }
    }
    .bottom {
      //margin-top: 0.3rem;
      .time {
        width: 4.1rem;
        height: 0.46rem;
        line-height: 0.46rem;
        font-weight: 900;
        text-align: center;
        font-size: 0.3rem;
        color: #3c58e5;
        // background: #c2eafb url("~@/assets/images/official_icon_1.png") no-repeat 0.1rem center;
        //background-size: 0.3rem;
        // position: relative;
        border-radius: 0rem 0.28rem 0.28rem 0;
        i {
          display: block;
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          width: 0;
          height: 0;
          border-color: #fff transparent;
          border-width: 0px 0px 0.46rem 0.1rem;
          border-style: solid;
        }
      }
      span {
        display: block;
        color: #fff;
        line-height: 0.58rem;
        text-align: center;
        letter-spacing: 0.02rem;
        border-radius: 0.29rem;
        font-size: 0.26rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        margin: 0.2rem auto;
        width: 2.2rem;
        height: 0.58rem;
        &.btn1 {
          background-color: #1662d9;
          // background: url(~@/assets/images/official_btn1.png) no-repeat;
          // background-size: 100% 100%;
        }
        &.btn2 {
          background-color: #dd2a2d;
          // background: url(~@/assets/images/official_btn2.png) no-repeat;
          // background-size: 100% 100%;
        }
        &.btn3 {
          background-color: #afafaf;
          // background: url(~@/assets/images/official_btn3.png) no-repeat;
          // background-size: 100% 100%;
        }
      }
      .o-tit {
        padding: 0.1rem 0.6rem 0 0.8rem;
        // margin-bottom: 0.26rem;
        background: url("~@/assets/images/official_icon_4.png") no-repeat 0.4rem
          0.2rem;
        font-size: 0.34rem;
        background-size: 0.3rem;
        font-weight: bold;
      }
      dl {
        width: 6.66rem;
        padding: 0.2rem 0.2rem;
        margin: 0 auto;
        background: #fff;
        border-radius: 0.22rem;
        dt {
          width: 1.72rem;
          float: left;
          margin-right: 0.3rem;
          position: relative;
          padding-top: 0.08rem;
          img {
            width: 1.54rem;
            height: 1.54rem;
            display: block;
            border-radius: 0.77rem;
            overflow: hidden;
            background: #f0f3f7;
            margin: 0 auto 0.1rem;
          }
        }
        dd {
          width: 4.12rem;
          float: left;
          h5 {
            height: 0.3rem;
            border-left: 0.05rem solid #ff6368;
            font-size: 0.3rem;
            color: #101010;
            font-weight: 500;
            line-height: 0.3rem;
            padding-left: 0.15rem;
            //margin-left: -0.2rem;
            display: inline-block;
            margin-right: 0.1rem;
            //margin-bottom: 0.15rem;
          }
          b {
            display: inline-block;
            font-size: 0.22rem;
            font-weight: 400;
            margin-bottom: 0.1rem;
            color: #332d5c;
            width: 4.2rem;
            /* overflow: hidden; */
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            /* padding-top: 0.2rem; */
            vertical-align: bottom;
            // border-bottom: 1px solid #312d59;
            // padding-bottom: 0.1rem;
          }
          div {
            font-size: 0.22rem;
            line-height: 0.28rem;
            color: #4d4d4d;
            padding: 0.2rem;
            background-color: #f1f1f8;
            border-radius: 0.1rem;
          }
        }
      }
    }
  }
}
</style>